import { render, staticRenderFns } from "./FactsPage.vue?vue&type=template&id=1d3bf8da&scoped=true"
import script from "./FactsPage.vue?vue&type=script&lang=js"
export * from "./FactsPage.vue?vue&type=script&lang=js"
import style0 from "./FactsPage.vue?vue&type=style&index=0&id=1d3bf8da&prod&scoped=true&lang=scss"
import style1 from "./FactsPage.vue?vue&type=style&index=1&id=1d3bf8da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3bf8da",
  null
  
)

export default component.exports